/* eslint-disable jira/filename-case */
// SCREENS

export const SCREEN = 'Screen' as const;
export const DRAWER = 'Drawer' as const;
export const MODAL = 'Modal' as const;
export const INLINE_DIALOG = 'InlineDialog' as const;
export const DROPDOWN = 'Dropdown' as const;
export const BANNER = 'Banner' as const;

export type Screens =
	| typeof SCREEN
	| typeof DRAWER
	| typeof MODAL
	| typeof INLINE_DIALOG
	| typeof DROPDOWN
	| typeof BANNER;

// EVENT TYPES
export const UI_EVENT_TYPE = 'UI' as const;
export const TRACK_EVENT_TYPE = 'TRACK' as const;
export const SCREEN_EVENT_TYPE = 'SCREEN' as const;
export const OPERATIONAL_EVENT_TYPE = 'OPERATIONAL' as const;

export type EventTypes =
	| typeof UI_EVENT_TYPE
	| typeof TRACK_EVENT_TYPE
	| typeof SCREEN_EVENT_TYPE
	| typeof OPERATIONAL_EVENT_TYPE;
